import type { KitStatus } from '@cheqroom/api';

export const getKitStatusColor = (status: KitStatus, isUnavailable = false): string | undefined => {
	if (isUnavailable) return 'text-red-500';

	switch (status) {
		case 'available':
			return 'text-green-500';
		case 'incomplete':
		case 'await_checkout':
			return 'text-yellow-500';
		case 'checkedout':
		case 'in_custody':
			return 'text-red-500';
		case 'expired':
			return 'text-gray-400';
		default:
			return undefined;
	}
};
